<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { type WorkspaceBreadcrumbModelItem } from "@modules/home/components/dashboard/workspace/HomeWorkspaceBreadcrumbItem.vue"

defineOptions({
    name: "HomeWorkspaceBreadcrumb",
})

// ================================
// PROPS
// ================================
withDefaults(
    defineProps<{
        model: WorkspaceBreadcrumbModelItem[]
        /** Désactive le dépôt (ex. utilisateur sans droit d’écriture). */
        disabledDrop?: boolean
    }>(),
    { disabledDrop: false }
)
</script>

<template>
    <!-- ================================ -->
    <!-- FIL D’ARIANE — DÉPÔT VERS DOSSIERS -->
    <!-- ================================ -->
    <BaseBreadCrumb
        v-if="model.length > 0"
        :model="model"
        :home="null"
        :pt="{ root: { 'aria-label': 'Fil d\'Ariane' } }"
        class="dashboard-workspace-breadcrumb breadcrumb-page text-sm text-surface-600 w-full"
    >
        <template #item="{ item, props: propsItem }">
            <HomeWorkspaceBreadcrumbItem
                :item="item as WorkspaceBreadcrumbModelItem"
                :props-item="propsItem"
                :disabled-drop="disabledDrop"
            />
        </template>
    </BaseBreadCrumb>
</template>
